<template>
  <div class="panel margin--bottom">
    <bar-card :bg="'border3'">
      <v-title>品牌产品</v-title>
      <div class="content">
        <div id="imageList" v-if="list.length > 0" class="tops flex">
          <swiper :options="swiperOption" class="imgcasesT" ref="mySwipers">
            <swiper-slide
              v-for="(it, index) in list"
              :key="index"
              class="swiper-slides"
            >
              <div class="cubeBox flex">
                <div class="topTitle">
                  <div class="xcTop flex">
                    <span style="margin-left: 13px">{{ it.name }}</span>
                  </div>
                </div>
                <div class="imgBox">
                  <div class="botTitle">
                    <div class="img">
                      <img
                        :src="it.logo"
                        class="imggs"
                        @click="previewClick(index)"
                      />
                    </div>
                  </div>
                </div>
                <div class="qrCode">
                  <div class="botTitle qrBox">
                    <div class="right_main flex">
                      <div class="q_nav flex">
                        <div class="imgBoxs">
                          <img
                            class="arround"
                            src="~images/index/home/pp_cplx.png"
                          />
                        </div>
                        <div class="wz_div flex">
                          <div>产品类型</div>
                          <div style="color:#00D2E4">
                            {{ it.type }}
                          </div>
                        </div>
                      </div>
                      <div class="q_nav flex">
                        <div class="imgBoxs">
                          <img
                            class="arround"
                            src="~images/index/home/ico_scqy.png"
                          />
                        </div>
                        <div class="wz_div flex">
                          <div>种植面积</div>
                          <div style="color:#00D2E4">{{ it.zzmj }}(万亩)</div>
                        </div>
                      </div>
                      <div class="q_nav flex">
                        <div class="imgBoxs">
                          <img
                            class="arround"
                            src="~images/index/home/pp_cpts.png"
                          />
                        </div>
                        <div class="wz_div flex">
                          <div>产量</div>
                          <!-- <div>种植数量</div> -->
                          <div style="color:#00D2E4">{{ it.zzsl }}(万吨)</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="swiper-button-prev" @click="prevs()"></div>
        <div class="swiper-button-next" @click="nexts()"></div>
      </div>
    </bar-card>
    <image-preview
      :show.sync="imgpre"
      :list="imglist"
      :initialIndex="initialIndex"
    ></image-preview>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getOrgCompanyProducts } from "@/api/home";
const imagePreview = () => import("@/components/imagePreview");
export default {
  components: { Swiper, SwiperSlide,imagePreview },
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        debugger: true,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        // autoplay: {
        //   loop: true,
        //   delay: 5000
        // },
        loop: true,
        autoplay: 5000,
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        centeredSlides: true, //<span style="color:rgb(68,68,68);font-family:'microsoft yahei';font-size:13px;">设定为true时，活动块会居中，而不是默认状态下的居左。</span>
        prevButton: ".swiper-button-prev", //上一张
        nextButton: ".swiper-button-next", //下一张
        notNextTick: true,
        pagination: ".swiper-pagination",
        speed: 300,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      list: [],
      imgUrl: "",
      imgpre: false,
      imgIndex: 0,
      imglist: [],
      initialIndex: 0
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleClick(e) {
      console.log(JSON.parse(e.target.dataset.obj));
    },
    swiperChange() {
      console.log(this.$refs.mySwipers.$swiper.activeIndex);
    },
    prevs() {
      this.$refs.mySwipers.$swiper.slidePrev();
      console.log(
        this.$refs.mySwipers.$swiper,
        "----swiper-",
        this.$refs.mySwipers
      );
    },
    nexts() {
      this.$refs.mySwipers.$swiper.slideNext();
    },
    previewClick(index) {
      this.imgIndex = index;
      // this.imgUrl = item.logo;
      if (index > 5) {
        index = index - 5;
      }
      this.initialIndex = index;
      this.imgpre = true;
    },
    closePre() {
      this.imgpre = false;
    },
    prev() {
      if (this.imgIndex === 0) {
        this.imgIndex = this.list.length - 1;
      } else {
        this.imgIndex = this.imgIndex - 1;
      }
      this.imgUrl = this.list[this.imgIndex].logo;
    },
    next() {
      if (this.imgIndex >= this.list.length - 1) {
        this.imgIndex = -1;
      }
      this.imgIndex = this.imgIndex + 1;
      this.imgUrl = this.list[this.imgIndex].logo;
    },
    getData() {
      getOrgCompanyProducts().then(res => {
        let arr = [];
        this.list=res.content.map(v => {
          v.logo = this.$config.imgIp + v.logo;
          if(v.logo){
            arr.push(v.logo)
          }
          return v;
        });
        this.imglist = arr;
      });
    },
    getData2() {
      let content = [
        {
          id: "40288af77ad32a90017ae347fc1d0000",
          name: "白糖罂",
          code: "0015",
          type: "荔枝",
          desc: "",
          status: 1,
          info: null,
          num: 955,
          by2: null,
          systemuser: "hnsc",
          systemusertime: 1627310783000,
          systemupdateuser: "hnsc",
          systemupdateusertime: 1627350621000,
          ord: 15,
          area: 44.06,
          orgCompanyPlace: null,
          logo:
            "https://www.nongjixxh.com:70/lzdp/upload/31221051-a607-41b1-8ae4-4b0937e31a46.jpg",
          orgCompanyProductsAuthsStr: null,
          typeStr: null,
          orgCompanyProductsPics: [],
          orgCompanyProductsAuths: [],
          onlineUrl: null
        },
        {
          id: "40288af77ad32a90017ae5a803a60003",
          name: "冰荔",
          code: "0016",
          type: "荔枝",
          desc: "",
          status: 1,
          info: null,
          num: 118,
          by2: null,
          systemuser: "hnsc",
          systemusertime: 1627350631000,
          systemupdateuser: null,
          systemupdateusertime: null,
          ord: 16,
          area: 5.13,
          orgCompanyPlace: null,
          logo:
            "https://www.nongjixxh.com:70/lzdp/upload/beeb3149-d1ed-4dfe-a0eb-408615269ec2.jpg",
          orgCompanyProductsAuthsStr: null,
          typeStr: null,
          orgCompanyProductsPics: [],
          orgCompanyProductsAuths: [],
          onlineUrl: null
        },
        {
          id: "40288af77ad32a90017ae5acc0d00004",
          name: "妃子笑",
          code: "0017",
          type: "荔枝",
          desc: "",
          status: 1,
          info: null,
          num: 175,
          by2: null,
          systemuser: "jyhy",
          systemusertime: 1627350942000,
          systemupdateuser: null,
          systemupdateusertime: null,
          ord: 17,
          area: 7.7,
          orgCompanyPlace: null,
          logo:
            "https://www.nongjixxh.com:70/lzdp/upload/6232f1f5-68d2-4ad8-b63d-6146472c7776.jpg",
          orgCompanyProductsAuthsStr: null,
          typeStr: null,
          orgCompanyProductsPics: [],
          orgCompanyProductsAuths: [],
          onlineUrl: null
        }
      ];

      this.list = content;
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(28% - 8px)
  font-size 0.06rem
.content
  height calc(100% - .2rem)
  position relative
  padding 0.09rem 0 0.07rem 0
  box-sizing border-box
.tops
  position relative
  height 100%
  width 92%
  margin 0 4%
  overflow hidden
  z-index 9
.imgcasesT
  width 100%
  position relative
  overflow initial
  margin 0
  height 100%
  z-index 5
.swiper-slides
  display flex
  align-content center
  justify-content center
  flex-direction column
  z-index 9
.swiper-button-prev, .swiper-button-next
  width 16px
  height 23px
  top 55%
.swiper-button-prev
  background url('~images/index/szjc/left.png') center no-repeat
  background-size 100% 100%
  left 5px
.swiper-button-next
  background url('~images/index/szjc/right.png') center no-repeat
  background-size 100% 100%
  right 5px
.cubeBox
  height 100%
  color #fff
  position relative
  background url('~images/index/home/ppcp_bj.png') center no-repeat
  background-size 100% 100%
  width calc(100% - 0.06rem)
  margin 0 0.03rem
.imgBox
  width 42%
  padding 0.13rem 0.14rem 0.13rem 0.15rem
  height calc(100% - 0px)
  box-sizing border-box
  position relative
  .img
    width 100%
    height 100%
    padding 0.03rem
    box-sizing border-box
    background url('~images/index/home/ppcp_kk.png') center no-repeat
    background-size 100% 100%
.qrCode
  flex 1
  padding 0.15rem 0.1rem 0.06rem 0
  height calc(100% - 0px)
  box-sizing border-box
  text-align center
.qrBox
  box-sizing border-box
  img
    margin-top 5px
.right_main
  height 100%
  width 100%
  flex-wrap wrap
.q_nav
  height 32%
  color #fff
  font-size 0.075rem
  width 100%
.num
  font-size 0.1rem
  color #00D2E4
.imgBoxs
  width 0.07rem
  display flex
  justify-content center
  align-items center
  position relative
  margin 0 0.025rem 0 0
.topTitle
  height 11%
  width 100%
  display flex
  align-items flex-end
  justify-content flex-end
  position absolute
  top 0
  right 0
.botTitle
  height 100%
  width 100%
.imggs
  width calc(100% - 0px)
  height calc(100% - 0px)
  cursor pointer
.xcTop
  background url('~images/index/home/ppcp_title.png') no-repeat center
  background-size 100% 100%
  height 100%
  width 33%
  justify-content center
  letter-spacing 2px
  font-size 0.06rem
  text-indent 0.08rem
.circle_one
  position absolute
  top -10px
  left -10px
  width 0.3rem
  height 0.3rem
  background #011E2E
  border-bottom-right-radius 50%
.circle_x
  position relative
  width 0.2rem
  height 0.2rem
  left 7px
.ewm
  height 0.1rem
.arround
  width 20px
@keyframes rotation
  from
    -webkit-transform rotate(0deg)
  to
    -webkit-transform rotate(360deg)
.circle_zj
  position absolute
  top 25%
  left 0
  width 100%
  height 100%
  justify-content center
.wz_div
  flex-wrap wrap
  margin-left 5px
.wz_div div
  width 100%
  text-align left
.num
  font-size 0.12rem
.imgDiv
  height calc(100% - 0.1rem)
  width 100%
  display flex
  justify-content center
  align-items center
.imgDiv img
  height 100%

.preview
  position fixed
  z-index 10
  top 0%
  background rgba(51, 51, 51, 0.5)
  bottom 0%
  right 0
  left 0
  img
    height 90%
  .closeBtn
    position absolute
    right 0
    background transparent
    border 0
    color #fff
    font-size 30px
.arrowBox
  width 5%
  height 100%
  justify-content center
  .arrowBtn
    background #333
    color #fff
    border 0
    font-size 30px
</style>
